import React, { useState } from 'react'

import './styles.scss'

// Components
import ModalFeedback from '../ModalFeedback'

// Images
import LogoFamilyHistory from './images/logoFamilyHistory'
import LogoGrant from './images/logoGrant'
import ImageBackground from './images/imageBackground'

export default () => {
  const [isShowFeedback, setIsShowFeedback] = useState<boolean>(false)

  const isMobileWidthWindow = window.window.innerWidth < 768

  return (
    <footer style={isMobileWidthWindow ? { position: 'relative' } : {}}>
      <div className={'container'}>
        <div className={'background'}>
          <ImageBackground />
        </div>
        <div className={'logos'}>
          <a href={'https://famiry.ru/'} target={'_blank'} rel="noreferrer">
            <LogoFamilyHistory />
          </a>
          <a
            href={'https://президентскиегранты.рф/'}
            target={'_blank'}
            rel="noreferrer"
          >
            <LogoGrant />
          </a>
        </div>
        <div className={'button-outer'}>
          <button className={'button'} onClick={() => setIsShowFeedback(true)}>
            Связаться с нами
          </button>
        </div>
        <div className={'urls'}>
          <a href={process.env.REACT_APP_TERMS_URL} className={'urls__link'}>
            Пользовательское соглашение
          </a>
          <a href={process.env.REACT_APP_POLICY_URL} className={'urls__link'}>
            Политика конфиденциальности
          </a>
        </div>
      </div>
      <ModalFeedback
        isOpen={isShowFeedback}
        onRequestClose={() => setIsShowFeedback(false)}
      />
    </footer>
  )
}
